import React, { useEffect, useState } from "react";

/**
 * Top-of-page scroll progress indicator.
 * Renders a 3px gradient bar that fills 0–100% as the user scrolls the page.
 */
export default function ScrollProgress() {
  const [pct, setPct] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      const h = document.documentElement;
      const max = (h.scrollHeight - h.clientHeight) || 1;
      const p = Math.min(100, Math.max(0, (h.scrollTop / max) * 100));
      setPct(p);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, []);

  return (
    <div className="md-scroll-progress" data-testid="scroll-progress" aria-hidden>
      <div className="md-scroll-progress-fill" style={{ width: `${pct}%` }} />
    </div>
  );
}
